export default "__VITE_ASSET__C1mpAQA7__"